import React from 'react';
import { Tween, Timeline } from 'react-gsap';
import PropTypes from 'prop-types';
import ErrorImage from 'assets/svg/error.svg';
import SuccessImage from 'assets/svg/success.svg';
import style from './SuccessErrorMessage.module.scss';
import { t } from '../../translations';

// eslint-disable-next-line react/prop-types
const SuccessErrorMessage = ({ message, smallImage = false }, ref) => {
  return (
    <div id="success-error-msg" className={smallImage ? style.containerSmall : style.container}>
      <Timeline
        target={
          <img
            ref={ref}
            id={message}
            alt={`${message} ${t('image')}`}
            src={message === 'success' ? SuccessImage : ErrorImage}
          />
        }
      >
        <Tween from={{ opacity: 0 }} to={{ opacity: 1 }} duration={0.5} ease={'Back.easeOut'} />
      </Timeline>
    </div>
  );
};

export default React.forwardRef(SuccessErrorMessage);

SuccessErrorMessage.propTypes = {
  message: PropTypes.string,
  smallImage: PropTypes.bool
};
